import { useTranslation } from "@shared/utils/internationalization";
import Box from "@ui-kit/layout/Box/Box.web";
import Text from "@ui-kit/typography/Text/Text.web";
import ParsedHtml from "@ui-kit/typography/ParsedHtml/ParsedHtml.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import type {
  PostPurchaseMessagesSharedProps,
  PostPurchaseMessage,
} from "./PostPurchaseMessages.props";

export default function PostPurchaseMessages(
  props: PostPurchaseMessagesProps
): JSX.Element | null {
  const { messages } = props;
  const { t } = useTranslation("checkout");

  if (!messages.length) return null;

  return (
    <Flex
      direction="column"
      gap={{ base: "xl", md: "2xl" }}
      data-testid="post-purchase-messages"
    >
      {messages.map((message: PostPurchaseMessage) => (
        <Box
          key={message.name}
          bg="yellow.100"
          border="1px solid"
          borderColor="yellow.900"
          borderRadius="sm"
          padding="0 16px"
          data-testid={`post-purchase-message-from-${message.name}`}
        >
          <Text
            color="yellow.900"
            fontSize="md"
            fontWeight="700"
            padding="24px 0"
            align="center"
          >
            {t("Important information from")} {message.name}
          </Text>
          <Box color="yellow.900">
            <ParsedHtml htmlString={message.message} />
          </Box>
        </Box>
      ))}
    </Flex>
  );
}

export type PostPurchaseMessagesProps = PostPurchaseMessagesSharedProps & {
  // Add any web specific props here.
};
